require('tinymce/tinymce');
require('tinymce/icons/default');
require('tinymce/themes/silver/theme');
require('tinymce-i18n/langs5/es');

require('tinymce/plugins/paste');
require('tinymce/plugins/link');
require('tinymce/plugins/code');
require('tinymce/plugins/lists');

require('tinymce/plugins/image');
require('tinymce/plugins/media');

const { default: axios } = require("axios");

export function init(target){

    let image_handler = $(target).attr('imageHandler');
    let images = typeof image_handler != 'undefined' && image_handler != '';

    tinymce.init({
        target: target,
        language: 'es',
        menubar: false,
        statusbar: false,
        plugins: 'lists link code paste' + (images ? ' image media' : ''),
        paste_as_text: true,
        file_picker_types: 'image',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist ' + (images ? 'image' : '') + ' link | removeformat code',
        relative_urls : false,
        remove_script_host : false,
        convert_urls: false,
        height: typeof $(target).attr('height') != 'undefined' ? $(target).attr('height') : 400,
        images_upload_handler: function(blobInfo, success, failure){

            if(images){

                let formData = new FormData();
                formData.append('filename', blobInfo.blob().name);
                formData.append('type', blobInfo.blob().type);
                formData.append('base64', blobInfo.base64());
        
                window.ajax.post(image_handler, formData, false, true)
                    .then((response) => {
                        success(response.data.location);
                    })
                    .catch((error) => {
                        if(typeof error.response.data.message != 'undefined'){
                            messages.error(error.response.data.message);
                        } else {
                            messages.error(error.response.statusText);
                        }
                    });
        
            }

        } 
    });

}